import { z } from 'zod/v4'
import { userSchema } from './user'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const logAggregateSchema = z.object({
    uuid: z.uuid().nullish(),
    title: z.string().nullish(),
})

export const logMetaSchema = z.object({
    'aggregate-root-uuid': z.uuid().nullish(),
    'aggregate-root-version': z.number().nullish(),
    'created-at': zDayJs.nullish(),
    ip: z.ipv4().nullish(),
    'stored-event-id': z.number().nullish(),
    url: z.url().nullish(),
    user_agent: z.string().nullish(),
})

export const logSchema = z.object({
    aggregate: logAggregateSchema.nullish(),
    aggregate_type: z.string().nullish(),
    aggregate_uuid: z.string().nullish(),
    aggregate_version: z.number().nullish(),
    created_at: zDayJs.nullish(),
    creator: userSchema.nullish(),
    creator_type: z.string().nullish(),
    creator_uuid: z.uuid().nullish(),
    group_type: z.string().nullish(),
    group_uuid: z.uuid().nullish(),
    id: z.number().nullish(),
    meta_data: logMetaSchema.nullish(),
    properties: z.any().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    version: z.number().nullish(),
})

export const logsSchema = z.array(logSchema)

export const paginatedLogsResponseSchema = z.object({
    data: logsSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveLogResponseSchema = z.object({
    data: logSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export type Log = z.infer<typeof logSchema>
export type Logs = z.infer<typeof logsSchema>
export type PaginatedLogsResponse = z.infer<typeof paginatedLogsResponseSchema>
export type RetrieveLogResponse = z.infer<typeof retrieveLogResponseSchema>
